import React from 'react';
import {useNavigate} from 'react-router-dom';

import CurrentDeposit from './CurrentDeposit';
import DepositHistory from './DepositHistory';
import {messageType, showMessages} from '../../helpers/message';
import {useAppSelector} from '../../hooks/useStore';
import {useGetPurchasesQuery} from '../../store/api/purchaseApi';
import {selectCurrentProfile} from '../../store/slices/userSlice';
import {DepositsParams} from '../../types/purchaseTypes';
import {BaseError} from '../../types/apiTypes';

const Deposits = ({accountingBalance}: DepositsParams) => {
    const activeProfile = useAppSelector(selectCurrentProfile);
    const activeAccount = activeProfile?.account;
    const navigate = useNavigate();
    const [curDepositValue, setCurDepositValue] = React.useState<number>(0);

    // This hook acts as an onMount. If staff tries to access the submenu item before selecting a membership
    // redirect to select member page, before attempting to fire the API call which would throw an error.
    React.useEffect(() => {
        if (!activeProfile || !activeAccount) navigate('/member_change');
    }, [navigate, activeProfile, activeAccount]);

    const {data: depositsData, error: depositsError, isFetching: depositsLoading} = useGetPurchasesQuery(
    {
        itemType: 'deposit',
        recipientType: 'account',
        recipientID: activeAccount?.id
    });

    // Set the current deposit amount.
    React.useEffect(() => {
        if (depositsData && depositsData.length !== 0) {
            setCurDepositValue(depositsData[0].balance);
        }
    }, [depositsData, navigate]);

    // Handle an error when fetching the deposits.
    React.useEffect(() => {
        if (depositsError) {
            const errorMessage = (depositsError as BaseError)?.data?.message || (depositsError as BaseError)?.error?.data?.message;
            showMessages(errorMessage, messageType.error);
        }
    }, [depositsError]);

    return (
        <>
            <CurrentDeposit
                loading={depositsLoading}
                curDepositValue={curDepositValue}
            />
            <DepositHistory
                loading={depositsLoading}
                totalRows={depositsData?.length ?? 0}
                purchases={depositsData || []}
                curDepositValue={curDepositValue}
                accountingBalance={accountingBalance}
            />
        </>
    )
}

export default Deposits;
